export default "__VITE_ASSET__a535534c__"